
import { NewUpdatedBaseUrl } from '../../BaseUrl/BaseUrl';
import { postApiWithAuthorization } from '../ApiMethod/ApiMethod';

const BaseURL = `${NewUpdatedBaseUrl}/UploadCloudflareImage`;


export const UploadImage = async (params) => {
    const url = `${BaseURL}/UploadImage`;
    const res = await postApiWithAuthorization(url, params, true);
    return res;
};


